/* eslint-disable no-array-constructor */
/* eslint-disable no-undef */
import { Toast } from 'antd-mobile';
import Browser from './browser';
import {
  PROD_TYPE,
  MINIPROGRAM_PATH_DIC,
  YSF_TAB_BAR_LIST,
  SHOP_TAB_BAR_LIST
} from './Consts';
import { getToken, getUUid } from './authUtil';
import Actions from '@/actions';
import QueryString from 'query-string';
import moment from 'moment';

export { getUUid };

/**
 * 判断是否为正确的手机号码
 * @param {string} phone 输入的手机号码
 */
export function isPhone(phone) {
  const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
  return reg.test(phone);
}

/**
 * 判断是否为正确的身份证号码
 * @param {string} idCard 输入的身份证号码
 */
export function isIdCard(idCard) {
  const rule =
    /(^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/;
  return rule.test(idCard);
}

/**
 * 判断是否为正确的邮箱地址
 * @param {string} email 输入的邮箱地址
 */
export function isEmail(email) {
  const rule =
    /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
  return rule.test(email);
}

/**
 * 判断是否输入数字+字母
 */
export function isCertificateNum(certificateNum) {
  const rule = /^[A-Za-z0-9]+$/;
  return rule.test(certificateNum);
}

/**
 * 判断是否为护照、台湾通行证
 */
export function isPassportOrTw(passportNum) {
  const rule = /^([a-zA-Z0-9]){9}$/;
  return rule.test(passportNum);
}

/**
 * 判断是否为港澳通行证
 */
export function isGa(passportNum) {
  const rule = /^([a-zA-Z0-9]){11}$/;
  return rule.test(passportNum);
}

/**
 * 跳转至下一页
 * @param {History} history histroy对象
 * @param {string} url 需要跳转的地址
 * @param {Boolean} replace 是否需要替换当前页
 * @param {Boolean} reLaunch 是否需要关闭其他页只保留当前页
 */
export function navigateTo({
  history,
  url,
  replace = false,
  reLaunch = false
}) {
  // if (Browser.ysfMiniprogram) {
  //   if (replace) {
  //     // eslint-disable-next-line no-undef
  //     upsdk.redirectTo({ url });
  //   } else if (reLaunch) {
  //     // eslint-disable-next-line no-undef
  //     upsdk.reLaunch({ url });
  //   } else {
  //     // eslint-disable-next-line no-undef
  //     upsdk.navigateTo({ url });
  //   }
  // } else {
  if (replace || reLaunch) {
    history.replace(url);
  } else {
    history.push(url);
  }
  // }
}

/**
 * 返回上一页
 * @param {Number} delta 返回的页面数
 */
export function navigateBack({ history, delta = 1 }) {
  // if (Browser.ysfMiniprogram) {
  //   // eslint-disable-next-line no-undef
  //   upsdk.navigateBack({});
  // } else {
  history.go(-delta);
  // }
}

/**
 * 替换 html 里 \r\n
 * @param {String} html html
 */
export function escape(html) {
  return html && html.replace(/\r?\n/g, '<br />');
}

/**
 * 判断是否还有下一页
 * @param {number} current 当前页数
 * @param {number} pages 总页数
 */
export function judgeHasNextPage({ current, pages }) {
  return current < pages;
}

/**
 * 获取分页以后的数据
 * @param {Array} prevList 之前的列表
 * @param {number} current 当前页数
 * @param {Array} records 当前分页的列表
 */
export function getPagingList(prevList, { current, records }) {
  const newList = current === 1 ? records : prevList.concat(records);
  return newList;
}

/**
 * 获取产品类型名称
 * @param {String} spuType 产品类型 PROD_TYPE
 * @param {Number} visaForm 签证类型 1-贴纸签证 2-电子签证
 */
export function getSpuTypeName(spuType, visaForm) {
  let typeName = PROD_TYPE[spuType];
  if (spuType === 'QZ') {
    if (visaForm === 1) {
      typeName = '贴纸签证';
    } else if (visaForm === 2) {
      typeName = '电子签证';
    }
  }
  return typeName;
}

function onBridgeReady() {
  WeixinJSBridge.call('closeWindow');
}

/**
 * 统一处理支付操作
 * @param {Object} params 调用支付所需参数
 * @param {Function} onTest 非云闪付环境测试函数
 */
export function doPay(params, history, tradeType) {
  return new Promise((resolve, reject) => {
    // 云闪付情况下 支付
    if (Browser.ysfMiniprogram) {
      let { tradeCode, ...rest } = params;
      // eslint-disable-next-line no-undef
      upsdk.pay({
        ...rest,
        success: function () {
          Toast.show({
            icon: 'success',
            content: '支付成功'
          });
          setTimeout(() => {
            resolve();
          }, 1000);
        },
        fail: function (err) {
          Toast.show({
            icon: 'fail',
            content: err.msg
          });
          setTimeout(() => {
            reject();
          }, 1000);
        }
      });
    } else {
      if (Browser.weiXin) {
        if (typeof WeixinJSBridge == 'undefined') {
          if (document.addEventListener) {
            document.addEventListener(
              'WeixinJSBridgeReady',
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        } else {
          // onBridgeReady();
        }

        let { appId, timeStamp, nonceStr, signType, paySign, tradeCode } =
          params;

        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId: appId, //公众号ID，由商户传入
            timeStamp: timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: nonceStr, //随机串
            package: params.package,
            signType: signType, //微信签名方式：
            paySign: paySign //微信签名
          },
          function (res) {
            // alert(JSON.stringify(res) + '-------------' + JSON.stringify(params));
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              // alert("wx-zhifu-ok" + res);
              Toast.show({
                content: '支付成功，正在处理...'
              });
              setTimeout(() => {
                // let detailUrl = `/orderDetail?tradeCode=${tradeCode}`;
                // if (tradeType) {
                //   detailUrl += `&tradeType=${tradeType}`;
                // }
                // // window.location.href = detailUrl
                // navigateTo({ history, url: detailUrl, replace: true });
                resolve();
              }, 1500);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
              Toast.show({
                icon: 'fail',
                content: '用户取消支付'
              });
              setTimeout(() => {
                resolve();
              }, 1500);
            } else {
              Toast.show({
                icon: 'fail',
                content: '支付失败'
              });
              setTimeout(() => {
                resolve();
              }, 1500);
            }
          }
        );
      } else {
        let { h5_url, tradeCode } = params;
        const { REACT_APP_HOST } = process.env;
        let detailUrl = `${REACT_APP_HOST}orderDetail?tradeCode=${tradeCode}`;
        if (tradeType) {
          detailUrl += `&tradeType=${tradeType}`;
        }
        let redirectUrl = '&redirect_url=' + encodeURIComponent(detailUrl);
        let newH5Url = h5_url + redirectUrl;
        if (Browser.ios) {
          window.location.href = newH5Url;
        } else {
          window.open(newH5Url);
        }
        setTimeout(() => {
          navigateTo({ history, url: detailUrl, replace: true });
        }, 1000);
      }

      // reject();
      // // TODO: 临时测试用
      // onTest && onTest();
    }
  });
}

/**
 * 统一处理上传文件
 * @param {File} file 上传的文件
 */
export function doUploadFile(file) {
  return new Promise(async (resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file);
    await fetch(`/api-admin/uploadFileOss`, {
      method: 'POST',
      headers: { Authorization: getToken() },
      body: formData
    })
      .then(async (res) => {
        const result = await res.json();
        const { code, dataMap, message } = result;
        if (code === 200) {
          resolve(dataMap);
        } else {
          Toast.show({
            icon: 'error',
            content: message
          });
          reject(message);
        }
      })
      .catch((e) => {
        Toast.clear();
        Toast.show({
          icon: 'error',
          content: '上传失败，请重试'
        });
        reject(e);
      });
  });
}

/**
 * 获取小程序appid
 */
export function getAppIdByResource({ urlType, fkAppid }) {
  return urlType === 2 ? fkAppid : 'wx48f645a551108cb8';
}

export async function wxshareApi(shareData, num) {
  const { wx } = window;
  const { NODE_ENV } = process.env;
  const configAction = await Actions.getWXConfig({ type: num });
  const { type, payload } = configAction;
  if (type === 'GET_WX_CONFIG') {
    wx.config({
      ...payload,
      debug: NODE_ENV === 'development',
      jsApiList: [
        'checkJsApi',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'updateAppMessageShareData',
        'updateTimelineShareData'
      ]
    });

    setTimeout(() => {
      // 调用分享方法
      wx.ready(function () {
        //需在用户可能点击分享按钮前就先调用
        wx.onMenuShareAppMessage(shareData);
        wx.onMenuShareTimeline(shareData);
        wx.updateAppMessageShareData(shareData);
        wx.updateTimelineShareData(shareData);
      });

      wx.error(function () {});
    },1000)
  }
}

/**
 * 判断链接是否可跳转
 * @param {Number} urlType 链接地址类型 1-小程序内部跳转 2-外部小程序跳转 3-H5链接跳转
 * @param {String} fkAppid 外部小程序 appid
 * @param {String} addressUrl 跳转路径
 */
export function checkResourceLinkExist({ urlType, fkAppid, addressUrl }) {
  if (urlType === 1) {
    // 匹配小程序的跳转路径
    const [pathUrl, pathParams] = addressUrl.split('?');
    const h5PathName = MINIPROGRAM_PATH_DIC[pathUrl];
    if (h5PathName) {
      // 如果找到对应的H5商城路径
      let turnUrl = h5PathName;
      if (pathParams) {
        turnUrl += `?${pathParams}`;
      }
      return {
        h5PathName,
        turnUrl
      };
    }
  } else if (urlType === 3) {
    return {
      turnUrl: addressUrl
    };
  }
  return false;
}

/**
 * 统一处理资源位点击事件
 * @param {History} history histroy对象
 * @param {Number} urlType 链接地址类型 1-小程序内部跳转 2-外部小程序跳转 3-H5链接跳转
 * @param {String} fkAppid 外部小程序 appid
 * @param {String} addressUrl 跳转路径
 * @param {Boolean} showError 如果不能直接打开连接 是否显示提示文案
 */
export function handleResourceClick({ history, data }, showError = false) {
  const { urlType } = data;
  const checkUrl = checkResourceLinkExist(data);
  if (checkUrl) {
    const { h5PathName, turnUrl } = checkUrl;
    if (urlType === 1) {
      // 小程序的跳转方式
      // 需要判断跳转方式(TAB_BAR 页面的跳转需使用 reLaunch)
      const tabBarList = Browser.ysfMiniprogram
        ? YSF_TAB_BAR_LIST
        : SHOP_TAB_BAR_LIST;
      const findInTabBar = tabBarList.find((item) => {
        return item.path === h5PathName;
      });
      navigateTo({ history, url: turnUrl, reLaunch: !!findInTabBar });
    } else {
      window.location.href = turnUrl;
    }
  } else {
    if (showError) {
      Toast.show({
        content: '微信小程序搜索“星玩家”体验更多功能'
      });
    }
  }
}

/**
 * 获取产品类型标签
 * @param {String} spuType 产品类型
 * @param {Number} visaForm 签证产品的签证类型
 */
export function getProdTypeName({ spuType, visaForm }) {
  let typeName = PROD_TYPE[spuType];
  if (spuType === 'QZ') {
    if (visaForm === 1) {
      typeName = '贴纸签证';
    } else if (visaForm === 2) {
      typeName = '电子签证';
    }
  }
  return typeName;
}

export function judgeIsIdCard(idCard) {
  var regIdCard =
    /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
  if (regIdCard.test(idCard)) {
    if (idCard.length === 18) {
      let month = idCard.substring(6, 14);
      if (moment(month).isSameOrBefore(moment())) {
        var idCardWi = new Array(
          7,
          9,
          10,
          5,
          8,
          4,
          2,
          1,
          6,
          3,
          7,
          9,
          10,
          5,
          8,
          4,
          2
        );
        var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2);
        var idCardWiSum = 0;
        for (var i = 0; i < 17; i++) {
          idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
        }
        var idCardMod = idCardWiSum % 11;
        var idCardLast = idCard.substring(17);
        if (idCardMod === 2) {
          if (idCardLast === 'X' || idCardLast === 'x') {
            return true;
          } else {
            return false;
          }
        } else {
          if (Number(idCardLast) === Number(idCardY[idCardMod])) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    } else {
      return true;
    }
  } else {
    return false;
  }
}

export function isNumber(str) {
  if (str) {
    for (let i = 0; i < str.length; i++) {
      if (!/\d{1,20}$/.test(str[i])) {
        return false;
      }
    }
  }
  return true;
}

export function isSpace(str) {
  if (str) {
    for (let i = 0; i < str.length; i++) {
      if (/^[\s]$/.test(str[i])) {
        return true;
      }
    }
  }
  return false;
}

export function handleValidator(required, value, validatorType) {
  if (required && !value) {
    return Promise.resolve();
  } else if (!required && !value) {
    return Promise.resolve();
  }

  if (validatorType && validatorType !== '') {
    switch (validatorType) {
      case 1:
        if (isSpace(value)) {
          return Promise.reject(new Error('请不要输入空格'));
        }
        break;
      case 2:
        if (!isNumber(value)) {
          return Promise.reject(new Error('请输入数字'));
        }
        break;
      case 3:
        if (!isPhone(value)) {
          return Promise.reject(new Error('请输入正确的手机号'));
        }
        break;
      case 4:
        if (!judgeIsIdCard(value)) {
          return Promise.reject(new Error('请输入正确的身份证号'));
        }
        break;
      default:
        break;
    }
  }
  return Promise.resolve();
}

export function getActCode() {
  return QueryString.parse(window.location.search)?.actCode || null;
}

export function getExamCode() {
  return QueryString.parse(window.location.search)?.examCode || null;
}

export function getPageCode() {
  return QueryString.parse(window.location.search)?.pageCode || null;
}

export function getPageForm() {
  return QueryString.parse(window.location.search)?.from || null;
}

export function getPageOrder() {
  return QueryString.parse(window.location.search)?.pageOrder || null;
}

export function getQrOpenid() {
  return QueryString.parse(window.location.search)?.QROPENID || null;
}

export function dealRichContent(content) {
  return content
    ? content.replace(/<img([\s\w"-=\/\.:;]+)/gi, '<img$1 class="rich-img"')
    : '';
}

export function normFileListToArray(fileList) {
  const newList = [];
  if (Array.isArray(fileList)) {
    fileList.forEach((file) => {
      const { status, url, response } = file;
      if (status === 'done') {
        if (url) {
          newList.push(url);
        } else if (response && response.code === 200) {
          newList.push(response.dataMap);
        }
      }
    });
  }
  return newList;
}

export function normArrayToFileList(list) {
  const newList = [];
  if (Array.isArray(list)) {
    list.forEach((item) => {
      if (item && item.uid) {
        newList.push(item);
      } else {
        const name = item.split('/').pop();
        newList.push({
          uid: item,
          status: 'done',
          url: item,
          name
        });
      }
    });
  }
  return newList;
}

export function getMonthName(str) {
  if (str === '' || str == null) {
    return '未知月'
  }
  return str.split('-')[1] + '月'
}

export function getMonthAndDate(str) {
  if (str == null || str === '') {
    return '未知日期'
  }
  return str.split('-')[1] + '-' + str.split('-')[2]
}

export function getWeekDay(str) {
  const date = new Date(str);
  if (isNaN(date.getTime())) {
    return '未知天';
  }
  const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  const weekday = date.getDay();
  return weekdays[weekday];
}

export function downImage(imgsrc, download) {
  var image = new Image();
  image.src = imgsrc + '?v=' + Math.random();
  image.crossOrigin = '*';
  image.onload = function () {
    var canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0, image.width, image.height);
    var base64 = canvas.toDataURL('image/png');
    var tmpa = document.createElement('a');
    tmpa.download = download;
    tmpa.href = base64;
    tmpa.target = base64;
    tmpa.click();
  };
}

// 考试题型判断
export function getSubjectType(type) {
  const subList = {1: '（单选题）', 2: '（多选题）', 3: '（简答题）', 6: '（判断题）'};
  return subList[type];
}